import React from "react"

const SurveyConfigurationContext = React.createContext(null)

export default SurveyConfigurationContext
